//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client.types';
import { getAxios, getBaseUrl } from './helpers';

/**
 * Gets the Investigation for the User.
 * @param recipeId Id of the Recipe for get.
 * @return Dto with investigation's data.
 */
export function get(recipeId: number, config?: AxiosRequestConfig | undefined): Promise<Types.InvestigationDto> {
    let url_ = getBaseUrl() + "/api/investigation/{recipeId}";
    if (recipeId === undefined || recipeId === null)
      throw new Error("The parameter 'recipeId' must be defined.");
    url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGet,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGet?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGet(_response);
    });
}

function processGet(response: AxiosResponse): Promise<Types.InvestigationDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initInvestigationDto(resultData200);
        return Promise.resolve<Types.InvestigationDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.InvestigationDto>(null as any);
}

/**
 * Creates a new Investigation for the User.
 * @param recipeId Id of the Recipe for get.
 * @param dto Dto with data for creation.
 * @return Dto with created Investigation
 */
export function createOrUpdateInvestigation(recipeId: number, dto: Types.CreateOrUpdateInvestigationDto, config?: AxiosRequestConfig | undefined): Promise<Types.InvestigationDto> {
    let url_ = getBaseUrl() + "/api/investigation/{recipeId}";
    if (recipeId === undefined || recipeId === null)
      throw new Error("The parameter 'recipeId' must be defined.");
    url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeCreateOrUpdateInvestigationDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigCreateOrUpdateInvestigation,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigCreateOrUpdateInvestigation?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCreateOrUpdateInvestigation(_response);
    });
}

function processCreateOrUpdateInvestigation(response: AxiosResponse): Promise<Types.InvestigationDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initInvestigationDto(resultData200);
        return Promise.resolve<Types.InvestigationDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.InvestigationDto>(null as any);
}
let _requestConfigGet: Partial<AxiosRequestConfig> | null;
export function getGetRequestConfig() {
  return _requestConfigGet;
}
export function setGetRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGet = value;
}
export function patchGetRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGet = patch(_requestConfigGet ?? {});
}

let _requestConfigCreateOrUpdateInvestigation: Partial<AxiosRequestConfig> | null;
export function getCreateOrUpdateInvestigationRequestConfig() {
  return _requestConfigCreateOrUpdateInvestigation;
}
export function setCreateOrUpdateInvestigationRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCreateOrUpdateInvestigation = value;
}
export function patchCreateOrUpdateInvestigationRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCreateOrUpdateInvestigation = patch(_requestConfigCreateOrUpdateInvestigation ?? {});
}